import { Theme, useMediaQuery } from "@mui/material";
import { Fragment } from "react";
import { 
    TextField,
    DatagridConfigurable, 
    List, 
    SearchInput, 
    useListContext, 
    TopToolbar, 
    FilterButton, 
    SortButton, 
    useGetResourceLabel, 
    DateInput 
} from "react-admin";
import MobileGrid from "./MobileGrid";
import { sharesCommiteeExporter } from "../../../../shared/utilities/sacopExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <SortButton fields={['dateRequestAction']} />
        <FilterButton />
        <SacopExportButton exporter={sharesCommiteeExporter} />
    </TopToolbar>
);

//TODO: agregar mas atributos para filtrar los registros.
const sectorFilters = [
    <SearchInput source="q" alwaysOn />,
    <DateInput source="dateRequestAction" />,
    // <BooleanInput source="active" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    // const { filterValues, setFilters, displayedFilters } = listContext;
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="dateRequestAction" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const SharesCommiteeList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        // filterDefaultValues={ { active: true }}
        sort={{ field: 'dateRequestAction', order: 'DESC' }}
        perPage={25}
        filters={sectorFilters}
        actions={<ListActions />}
        exporter={sharesCommiteeExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default SharesCommiteeList;

